{
    "general": {
        "back": "Back",
        "cancel": "Cancel",
        "close": "Close",
        "ok": "Ok",
        "next": "Next",
        "languages": {
            "en": "English",
            "fr": "Français"
        }
    },
    "forms": {
        "errors": {
            "required": "{{field}} is required.",
            "email": "{{field}} is not a valid email address.",
            "minlength": "{{field}} must be at least {{requiredLength}} characters.",
            "maxlength": "{{field}} cannot exceed {{requiredLength}} characters.",
            "min": "{{field}} must be at least {{min}}.",
            "max": "{{field}} cannot exceed {{max}}.",
            "pattern": "{{field}} format is invalid.",
            "invalid": "{{field}} is invalid.",
            "minSelected": "Please select at least {{required}}."
        }
    },
    "shared": {
        "grid": {
            "loading": "Loading...",
            "pageReport": "Showing {first}–{last} of {totalRecords}",
            "locale": {
                "loadingOoo": "Loading...",
                "loadingError": "ERR",
                "noRowsToShow": "No Rows To Show",
                "empty": "Choose One",
                "blanks": "(Blanks)",
                "true": "True",
                "false": "False",
                "contains": "Contains",
                "notContains": "Does Not Contain",
                "equals": "Equals",
                "notEqual": "Does Not Equal",
                "startsWith": "Begins With",
                "endsWith": "Ends With",
                "lessThan": "Less Than",
                "greaterThan": "Greater Than",
                "lessThanOrEqual": "Less Than Or Equal",
                "greaterThanOrEqual": "Greater Than Or Equal",
                "inRange": "Between",
                "inRangeStart": "From",
                "inRangeEnd": "To",
                "blank": "Blank",
                "notBlank": "Not Blank",
                "before": "Before",
                "after": "After",
                "filterOoo": "Filter...",
                "searchOoo": "Search...",
                "applyFilter": "Apply",
                "resetFilter": "Reset",
                "clearFilter": "Clear",
                "cancelFilter": "Cancel",
                "selectAll": "(Select All)",
                "selectAllSearchResults": "(Select All Search Results)",
                "noMatches": "No matches",
                "andCondition": "AND",
                "orCondition": "OR",
                "sortAscending": "Sort Ascending",
                "sortDescending": "Sort Descending",
                "sortUnSort": "Clear Sort",
                "pinColumn": "Pin Column",
                "pinLeft": "Pin Left",
                "pinRight": "Pin Right",
                "noPin": "No Pin",
                "autosizeThiscolumn": "Autosize This Column",
                "autosizeAllColumns": "Autosize All Columns",
                "resetColumns": "Reset Columns",
                "expandAll": "Expand All",
                "collapseAll": "Collapse All"
            }
        }
    },
    "header": {
        "userMenu": {
            "settings": "Settings",
            "darkMode": "Dark Mode",
            "developerMode": "Developer Mode",
            "signOut": "Sign out",
            "exit": "Exit"
        },
        "uploadProgress": {
            "indicator": {
                "toggleAriaLabel": "Toggle upload progress details"
            },
            "title": {
                "inProgress": "Uploading files…",
                "completed": "Upload complete",
                "partialFailure": "Upload finished with errors"
            },
            "hideAriaLabel": "Hide upload progress",
            "summary": {
                "completed": "{{completed}} / {{total}} completed",
                "failed": "{{failed}} failed"
            },
            "fileStatus": {
                "pending": "Queued",
                "inProgress": "Encrypting…",
                "completed": "Finished",
                "failed": "Failed",
                "preparing": "Preparing…",
                "sharing": "Uploading to secure share…",
                "overall": "Overall",
                "archiveFile": "File {{index}} of {{total}}",
                "rows": "{{count}} rows",
                "slow": "Taking longer than expected…"
            },
            "connection": {
                "reconnecting": "Reconnecting…",
                "lost": "Connection lost. Retrying…"
            },
            "noErrorDetail": "No error detail available.",
            "dismiss": "Dismiss",
            "dismissAriaLabel": "Dismiss upload",
            "sessionExpired": {
                "summary": "Session expired",
                "detail": "Your session expired during processing. Sign in again and use Retry for the failed files."
            }
        }
    },
    "sidebar": {
        "pages": {
            "workPackages": "Work Packages",
            "inbox": "Inbox"
        },
        "categories": {
            "activeWorkPackages": "Active Work Packages"
        },
        "statusCard": {
            "title": "System Status",
            "statuses": {
                "online": "Online",
                "unverified": "Couldn't verify"
            }
        }
    },
    "splash": {
        "starting": "Starting the Privanot service…",
        "startingAttempt": "Starting the Privanot service (attempt {{attempt}})",
        "connecting": "Connecting to the Privanot service...",
        "tunnelConnecting": "Establishing secure connection…",
        "tunnelTimeout": "The secure connection is taking longer than expected. Please retry.",
        "serviceFailed": "The Privanot service could not be started.",
        "error": "Could not connect to the Privanot service.",
        "unauthorized": "You are not authorized to connect to the Privanot service.",
        "retry": "Retry",
        "closeApp": "Close app"
    },
    "errors": {
        "websocket": {
            "summary": "Server error",
            "unknown": "An unexpected error occurred."
        },
        "file": {
            "sessionExpired": "Session expired: sign in again and use Retry for the failed files"
        }
    },
    "features": {
        "settings": {
            "title": "Settings",
            "sharingKey": {
                "title": "Sharing keys",
                "emptyBody": "You don't have sharing keys yet. Files shared with you can't be received until you register them.",
                "registered": {
                    "title": "Registered",
                    "encryptionKey": "Encryption key",
                    "at": "Registered on"
                },
                "generate": {
                    "tab": "Generate",
                    "description": "Generate a fresh RSA-4096 encryption keypair. The private key is stored securely on this device only — there is no backup.",
                    "button": "Generate keys",
                    "confirmHeader": "Generate sharing keys?",
                    "confirmBody": "Are you sure you want to generate new sharing keys? This device will be your only receiver for shared files."
                },
                "import": {
                    "tab": "Import",
                    "description": "Paste your existing RSA-4096 PEM-encoded encryption private key.",
                    "encryptionPemLabel": "Encryption key PEM",
                    "encryptionPemPlaceholder": "-----BEGIN PRIVATE KEY-----\n...\n-----END PRIVATE KEY-----",
                    "button": "Import keys"
                },
                "toastGenerated": "Sharing keys generated",
                "toastImported": "Sharing keys imported",
                "toastExportGenerated": "Sharing keys generated. Copy them before leaving this page.",
                "hostedGenerate": {
                    "button": "Generate keys",
                    "confirmHeader": "Generate sharing keys?",
                    "confirmBodyPrimary": "A new RSA-4096 encryption keypair will be generated. Nothing changes until you replace the EncryptionKey value in your service configuration and restart the service.",
                    "confirmBodySecondary": "Before restarting the service with the new key, ask your administrator to revoke your currently registered key. Otherwise the new key won't be registered and files shared with you can't be decrypted.",
                    "resultWarning": "This key is only shown once. Copy it now, you will not be able to retrieve it later.",
                    "encryptionKeyLabel": "Encryption key",
                    "encryptionFingerprintLabel": "Encryption key fingerprint",
                    "copy": "Copy",
                    "copied": "Copied"
                },
                "loadFailedBanner": "Your encryption keys couldn't be loaded on this device. Any past shares are permanently inaccessible. Generate a new pair to receive future shares.",
                "loadFailedBannerLink": "Generate now",
                "hostedManagedTitle": "Managed by your administrator",
                "hostedManagedBody": "Sharing keys for this workspace are provisioned centrally. Contact your administrator to rotate or replace them.",
                "hostedLoadFailedBanner": "Sharing keys unavailable. Contact your administrator.",
                "revoked": {
                    "title": "Sharing access revoked",
                    "body": "Your administrator has revoked your sharing access. You will not receive new shared files until it is restored. Contact your administrator.",
                    "panelTitle": "Revoked",
                    "at": "Revoked on"
                },
                "localOnly": {
                    "title": "Not yet registered with your administrator",
                    "body": "Keys exist on this device but the administrator has not confirmed them. Sharing is unavailable until registration completes.",
                    "panelTitle": "Awaiting registration"
                },
                "mismatch": {
                    "banner": "Your sharing key doesn't match the one registered with your administrator. Files shared with you can't be decrypted.",
                    "bannerLink": "View details",
                    "title": "Sharing key mismatch",
                    "body": "The key on this device isn't the one your administrator has on record, so files shared with you can't be decrypted. Generate new keys to register this device again. Files already shared with the previous key will need to be shared again.",
                    "hostedBody": "The EncryptionKey in the service configuration isn't the key your administrator has on record, so files shared with you can't be decrypted. Restore the matching key in the configuration, or ask your administrator to revoke the registered key and then restart the service. If the registered key is revoked, files already shared with it will need to be shared again.",
                    "panelTitle": "Key mismatch",
                    "registeredKey": "Registered with administrator"
                }
            }
        },
        "workPackages": {
            "title": "Work Packages",
            "assignedList": {
                "active": "Active Work Packages",
                "archived": "Archived Work Packages"
            },
            "dashboard": {
                "fields": {
                    "createdAt": "Created At"
                },
                "status": {
                    "active": "Active",
                    "archived": "Archived"
                },
                "noFilesUploadedYet": {
                    "title": "Work Package is empty",
                    "description": "No files have been uploaded to the work package yet.",
                    "action": "Initialize Work Package"
                },
                "metrics": {
                    "numFiles": "Number of Files",
                    "encryptedColumns": "Encrypted Columns",
                    "rowsEncrypted": "Rows Encrypted",
                    "encryptionCoverage": "Encryption Coverage",
                    "filesProcessed": "Files Processed",
                    "rowsProcessed": "Total Rows Processed",
                    "filesDelivered": "Files Delivered to SFTP",
                    "complete": "Complete",
                    "inProgress": "In progress"
                },
                "pipeline": {
                    "title": "Pipeline Status",
                    "completedCount": "{{completed}}/{{total}} completed",
                    "stages": {
                        "schema": "Schema",
                        "mapping": "Mapping",
                        "encryption": "Encryption",
                        "pseudonymization": "Pseudo.",
                        "output": "Output"
                    }
                },
                "fileDetails": {
                    "title": "File Details",
                    "fileName": "File Name",
                    "fileSize": "File Size",
                    "rows": "Rows",
                    "columnsSelected": "Columns Selected",
                    "status": "Status",
                    "error": "Error",
                    "startedAt": "Started At",
                    "completedAt": "Completed At",
                    "duration": "Duration"
                },
                "operationDetails": {
                    "title": "Operation Details",
                    "name": "Name",
                    "status": "Status",
                    "createdAt": "Created At",
                    "startedAt": "Started At",
                    "completedAt": "Completed At",
                    "duration": "Duration",
                    "files": "Files",
                    "recipients": "Shared with",
                    "noRecipients": "Not shared with any other client"
                },
                "operations": {
                    "title": "Operations",
                    "uploadNewFile": "Upload a new file",
                    "addFile": "Add File",
                    "refresh": "Refresh",
                    "table": {
                        "operationLabel": "Operation",
                        "loading": "Loading...",
                        "headers": {
                            "name": "Name",
                            "fileSize": "Size",
                            "rowCount": "Rows",
                            "columnsSelectedCount": "Columns Selected",
                            "duration": "Duration",
                            "status": "Status",
                            "sharedWith": "Shared with"
                        },
                        "operationStatus": {
                            "queued": "Queued",
                            "running": "Running",
                            "succeeded": "Succeeded",
                            "partialSuccess": "Partial Success",
                            "failed": "Failed"
                        },
                        "shareStatus": {
                            "uploadPending": "Upload Pending",
                            "uploaded": "Uploaded",
                            "completed": "Completed",
                            "expired": "Expired",
                            "failed": "Failed",
                            "notSent": "Not sent",
                            "description": {
                                "uploadPending": "Waiting for the encrypted file to be uploaded to the shared location",
                                "uploaded": "Shared file is ready to be downloaded by the recipient",
                                "completed": "Downloaded by the recipient",
                                "expired": "Expired before the recipient could download it",
                                "notSent": "Not sent because a file failed. Retry the failed files to send it."
                            },
                            "failureReason": {
                                "target_client_encryption_key_not_valid": "The recipient's encryption key is not set up or is no longer valid",
                                "sender_upload_failed": "The encrypted file could not be uploaded",
                                "recipient_revoked": "The recipient's sharing access was revoked",
                                "default": "Failed to share the file to this recipient"
                            }
                        },
                        "fileStatus": {
                            "queued": "Queued",
                            "running": "Encrypting",
                            "succeeded": "Succeeded",
                            "failed": "Failed"
                        },
                        "actions": {
                            "download": "Download",
                            "moreDetails": "Details",
                            "retry": "Retry",
                            "retryUploadActive": "Wait for the current upload to finish"
                        }
                    }
                }
            },
            "upload": {
                "emptyState": {
                    "title": "Choose which files to pseudonymize",
                    "description": "Allowed file formats are: csv, xlsx, zip, tar.gz",
                    "action": "Choose Files"
                },
                "selection": {
                    "heading": "Choose which files you want to pseudonymize",
                    "filterPlaceholder": "Search files and folders...",
                    "corruptArchive": "corrupt — cannot be read",
                    "rescan": "Rescan",
                    "empty": "No documents found"
                },
                "columns": {
                    "heading": "Select which columns should be pseudonymized for each selected file"
                },
                "steps": {
                    "select": {
                        "label": "Select documents",
                        "instruction": "Choose the files you want to pseudonymize."
                    },
                    "configure": {
                        "label": "Configure columns",
                        "instruction": "Pick at least one column to pseudonymize for each file."
                    },
                    "share": {
                        "label": "Share with clients",
                        "instruction": "Optionally share this operation with other clients on the work package."
                    },
                    "review": {
                        "label": "Review & confirm",
                        "instruction": "Name the operation and confirm the details before uploading."
                    }
                },
                "share": {
                    "emptyState": "No other clients are assigned to this work package.",
                    "loading": "Loading clients…",
                    "loadError": "Couldn't load the clients for this work package. Please try again.",
                    "expiry": {
                        "ariaLabel": "Share expiry",
                        "presets": {
                            "day1": "1 day",
                            "day3": "3 days",
                            "day7": "7 days",
                            "day30": "30 days"
                        }
                    }
                },
                "review": {
                    "operationName": "Operation name",
                    "fileCount": "Files",
                    "sharedWith": "Shared with",
                    "sharedWithNobody": "Not shared with any other client",
                    "notSet": "Not set",
                    "stats": {
                        "files": "Files",
                        "totalSize": "Total size",
                        "recipients": "Recipients"
                    },
                    "preflight": {
                        "title": "Upload checklist",
                        "nameSet": "Operation name set",
                        "columnsConfigured": "All files have columns configured ({{configured}} of {{total}})",
                        "recipientsShared": "Shared with {{count}} recipient(s)",
                        "uploadInProgress": "An upload is already in progress"
                    },
                    "manifest": {
                        "title": "File manifest",
                        "itemCount": "{{count}} items",
                        "expand": "Expand",
                        "collapse": "Collapse",
                        "typeDocument": "document",
                        "typeArchive": "archive",
                        "mappedColumns": "{{count}} columns mapped",
                        "archiveEntries": "{{mapped}} of {{total}} entries mapped"
                    }
                },
                "configuredCount": "{{configured}} of {{total}} files configured",
                "operationName": {
                    "label": "Operation name",
                    "placeholder": "e.g. Q3 onboarding batch"
                },
                "warnings": {
                    "allFilesNeedColumns": "All files must have at least one column selected to continue.",
                    "uploadInProgress": "An upload is already in progress. Please wait for it to finish before starting another."
                },
                "actions": {
                    "editSelection": "Edit selection",
                    "confirmAndAddToWorkPackage": "Confirm and add to work package"
                },
                "table": {
                    "headers": {
                        "fileName": "File Name",
                        "fileSize": "Size",
                        "filePath": "Path",
                        "selectedColumns": "Selected Columns",
                        "actions": "Actions"
                    },
                    "actions": {
                        "selectColumns": "Select columns",
                        "modifyColumns": "Edit columns"
                    },
                    "emptyMessage": "Please select files to upload",
                    "archiveSummary": "{{configured}} of {{total}} files configured",
                    "fileStatus": {
                        "noColumnsSelected": "No columns selected",
                        "archiveHasUnconfiguredFiles": "Not all files in this archive have been configured.",
                        "analyzing": "Analyzing file structure...",
                        "analysisFailed": "Could not analyze file"
                    }
                },
                "columnSelection": {
                    "title": "Select columns to pseudonymize",
                    "description": "Choose the columns containing personal data to pseudonymize.",
                    "searchPlaceholder": "Search columns...",
                    "columnNameHeader": "Column name",
                    "selectAllSuggested": "Select all (suggested)",
                    "noSuggestedColumns": "No suggested columns found.",
                    "suggestedBadge": "Suggested",
                    "selectedCount": "{{count}} columns selected",
                    "confirm": "Confirm selection",
                    "noResults": "No columns match your search."
                },
                "retry": {
                    "notice": "Select the source file and columns again. The files will be re-processed into the existing operation.",
                    "noCandidates": "No matching file was found in the upload folder for: {{files}}"
                }
            }
        },
        "inbox": {
            "title": "Inbox",
            "subtitle": "Files shared with you land here. Click download to write a share to your destination storage.",
            "actions": {
                "refresh": "Refresh",
                "downloadAll": "Download all"
            },
            "empty": {
                "title": "No incoming shares",
                "body": "When another client shares an operation with you, it will appear here."
            },
            "counter": "{{count}} pending share(s)",
            "pending": {
                "title": "Pending"
            },
            "history": {
                "title": "Past shares",
                "subtitle": "Downloaded and expired shares from the last retention window.",
                "counter": "{{count}} past share(s)",
                "empty": {
                    "title": "No past shares",
                    "body": "Once a share has been downloaded or expires, it will appear here."
                },
                "actions": {
                    "refresh": "Refresh history"
                },
                "headers": {
                    "downloaded": "Downloaded",
                    "expiredAt": "Expired at"
                }
            },
            "status": {
                "delivered": "Downloaded",
                "completed": "Completed",
                "expired": "Expired",
                "failed": "Failed"
            },
            "table": {
                "headers": {
                    "files": "Files",
                    "sender": "Sender",
                    "operation": "Operation",
                    "received": "Received",
                    "status": "Status"
                },
                "status": {
                    "pending": "Pending",
                    "downloadingWithPercent": "Downloading {{percent}}%"
                },
                "actions": {
                    "download": "Download",
                    "downloading": "Downloading…",
                    "downloaded": "Downloaded"
                }
            },
            "toast": {
                "received": {
                    "summary": "New share received",
                    "detail": "{{sender}} shared \"{{operation}}\" with you."
                },
                "failed": {
                    "summary": "Download failed",
                    "detail": "The share could not be downloaded."
                }
            }
        },
        "fileUpload": {
            "action": "Upload file",
            "dialog": {
                "title": "Upload a file to your storage",
                "description": "The file is sent to your organization's storage server and can then be used in any work package.",
                "choose": "Choose file",
                "accepted": "Accepted: CSV, XLSX, ZIP, TAR.GZ, TGZ",
                "upload": "Upload",
                "uploading": "Uploading {{fileName}}…",
                "uploadAnother": "Upload another file",
                "retry": "Try again",
                "success": "{{fileName}} was uploaded. It is available in \"Select documents\" of any work package after Rescan.",
                "failed": "{{fileName}} could not be uploaded."
            },
            "errors": {
                "invalid_name": "This file name can't be used. Rename the file and try again.",
                "unsupported_type": "This file type isn't supported. Use CSV, XLSX, ZIP, TAR.GZ or TGZ.",
                "too_large": "The file is larger than the allowed maximum.",
                "already_exists": "A file with this name already exists on your storage. Rename the file and try again.",
                "storage_unreachable": "Your storage server can't be reached. Check the server or contact your administrator.",
                "storage_auth_failed": "Your storage server refused the connection credentials. Contact your administrator.",
                "write_denied": "Your storage server refused to save the file. Contact your administrator.",
                "network": "The Client Service can't be reached. Check your connection and try again.",
                "unknown": "The upload failed. Try again."
            }
        }
    },
    "bastion": {
        "pending": {
            "title": "Secure connection key is pending approval",
            "message": "Your device has requested access. An administrator needs to approve it before you can continue."
        },
        "revoked": {
            "title": "Access was revoked by an administrator",
            "message": "This device's access was revoked. Contact your Privanot administrator to restore it."
        },
        "rejected": {
            "title": "Secure connection key request was rejected",
            "message": "This device's access request was rejected. Contact your Privanot administrator or set up a new key."
        },
        "conflict": {
            "title": "Secure connection key already in use",
            "message": "This secure connection key is already registered to a different client and cannot be used. Contact your Privanot administrator."
        },
        "none": {
            "title": "No secure connection key set up",
            "message": "This device has no secure connection key. Contact your Privanot administrator to finish setup."
        },
        "checkAgain": "Check again"
    },
    "tunnel": {
        "reconnectingAttempt": "Reconnecting… (attempt {{attempt}})",
        "reason": {
            "auth_rejected": "The bastion rejected this device's connection key.",
            "host_key_mismatch": "The Privanot bastion's identity could not be verified.",
            "invalid_config": "The secure connection is misconfigured.",
            "port_in_use": "The local connection port is already in use.",
            "unreachable": "Could not reach the Privanot bastion.",
            "retries_exhausted": "Could not connect to the Privanot bastion after several attempts."
        }
    },
    "auth": {
        "signIn": {
            "title": "Sign in to Privanot",
            "subtitle": "Use your organization's Microsoft account.",
            "button": "Sign in with Microsoft",
            "inProgress": "Complete the sign-in in your browser…",
            "cancel": "Cancel",
            "retry": "Retry"
        },
        "errors": {
            "unreachable": "Microsoft sign-in cannot be reached from your network. Please contact your IT department.",
            "accessDenied": "Access denied. Your account is not authorized to use Privanot. Please contact your IT department.",
            "tokenVersion": "Microsoft sign-in for Privanot is not set up correctly (the app registration must issue v2 tokens). Please contact your IT department.",
            "sessionExpired": "Your session has expired. Please sign in again.",
            "serviceUnavailable": "Could not reach the Privanot service.",
            "unknown": "Sign-in failed. Please try again.",
            "sessionExpiredDuringRun": "Your session expired while files were being processed. The file in progress finishes and the remaining files fail. Sign in again and use Retry for the failed files."
        },
        "browserPage": {
            "success": "Sign-in complete. You can close this tab and return to Privanot.",
            "error": "Sign-in failed. You can close this tab and return to Privanot."
        },
        "signOutConfirm": {
            "title": "Sign out during an upload?",
            "message": "An operation is still running. If you sign out now, the file in progress will finish but the remaining files will fail.",
            "confirm": "Sign out",
            "cancel": "Stay signed in"
        },
        "unavailable": {
            "title": "Privanot is not available right now"
        }
    }
}
